import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import styles from "./IaMarks.module.scss";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import { Close } from "@material-ui/icons";
import { API } from "aws-amplify";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";
import swal from "sweetalert";
import Skeleton from "@material-ui/lab/Skeleton";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .slick-arrow": {
      color: "black",
    },
    "& .slick-prev:before": {
      color: "black",
      fontSize: 27,
    },
    "& .slick-next:before": {
      color: "black",
      fontSize: 27,
    },
    "& .MuiGrid-root": {},
    "& .MuiGrid-item": {},
    "& .MuiGrid-grid-xs-6": {},
  },
  paperAnnounce: {
    textAlign: "start",
    color: theme.palette.text.secondary,
    width: "100%",
  },
  paperEvents: {
    textAlign: "start",
    color: theme.palette.text.secondary,
    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
  },
  paper: {
    "& .MuiDialog-paperWidthSm": {
      height: "80%",
      width: "90%",
      padding: "50px 0px 0px",
      "@media (min-height: 800px)": {
        height: "72rem",
      },
    },
  },
  content: {
    ".MuiDialogContent-root": {
      overflowY: "hidden",
    },
  },
  mainGrid: {
    width: "100%",
    margin: 0,
    "& > div": {
      padding: "15px!important",
    },
  },
  listContents: {
    marginLeft: "1rem",
    justifyContent: "left",
    "& > p": {
      overflow: "auto",
    },
  },
  modalHeading: {
    position: "absolute",
    top: "0",
    left: "30px",
    maxWidth: "800px",
    "@media (max-width: 520px)": {
      padding: "16px 0px",
    },
  },
  paperSectionMainStyle: {
    width: "40rem",
    backgroundColor: "#d5e3ef",
    padding: "1rem",
    boxShadow: "0 0 1px #0000002e",
    "@media (max-width: 520px)": {
      width: "100%",
    },
  },
  paperSectionStyle: {
    boxShadow: "0 0 8px #0000002e",
    marginTop: "2rem",
  },
  buttonSectionStyle: {
    boxShadow: "0 0 8px #0000002e",
    padding: "1rem",
    fontSize: "1.5rem",
  },
}));

const IaMarks = (props) => {
  const { handleClose, rows } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const userDetails = useSelector(authData);

  // State variables
  const [selectedSemester, setSelectedSemester] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("0");
  const [semesters, setSemesters] = useState([]);
  const [coursesBySemester, setCoursesBySemester] = useState({});
  const [iaMarksData, setIaMarksData] = useState([]);
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
  };

  const tdStyle1 = {
    padding: "8px",
    textAlign: "left",
    fontSize: "14px",
  };

  const thStyle = {
    backgroundColor: "var(--sub-heading-color) !important",
    padding: "8px",
    textAlign: "left",
    fontSize: "16px",
    color: "white",
  };

  useEffect(() => {
    getProgramsDetails();
  }, []);

  async function getProgramsDetails() {
    const bodyParam = {
      body: {
        bpid: userDetails.curprgcou?.bpid,
        oid: config.aws_org_id,
        pid: userDetails.curprgcou?.pid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    try {
      const programs = await API.post(
        config.aws_cloud_logic_custom_name,
        `/getProgramsDetails`,
        bodyParam
      );

      const groupedBySemester = programs.pcurriculum.reduce((acc, course) => {
        const sem = course.semester;
        if (!acc[sem]) {
          acc[sem] = [];
        }
        acc[sem].push(course);
        return acc;
      }, {});

      const semestersList = Object.keys(groupedBySemester).sort();
      setSemesters(semestersList);
      setCoursesBySemester(groupedBySemester);

      if (semestersList.length > 0) {
        const firstSemester = semestersList[0];
        setSelectedSemester(firstSemester);
        const topicids = groupedBySemester[firstSemester].map(
          (course) => course.btid
        );
        getIaMarks(topicids);

        setLoading(false);
      }
    } catch (error) {
      console.error("Error in getProgramsDetails:", error);
      setLoading(false);
    }
  }

  async function getIaMarks(topicids) {
    if (!topicids || topicids.length === 0) {
      setIaMarksData([]);
      setCheckedUsers([]);
      return;
    }

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou?.bpid,
        topicids,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/getIaMarks`,
        bodyParam
      );
      const updatedResponse = response.map((item) => ({
        ...item,
        selected: false,
        topics: item.topics || {},
      }));
      setIaMarksData(updatedResponse);
      setCheckedUsers([]);
    } catch (error) {
      console.error("Error in getIaMarks:", error);
      setIaMarksData([]);
      setCheckedUsers([]);
      swal("Error", "Failed to fetch IA marks", "error");
    } finally {
      setLoading(false);
    }
  }

  const handleSemesterChange = (event) => {
    const newSemester = event.target.value;
    setSelectedSemester(newSemester);
    setSelectedCourse("0");

    const topicids =
      coursesBySemester[newSemester]?.map((course) => course.btid) || [];
    getIaMarks(topicids);
  };

  const handleCourseChange = (event) => {
    const newCourse = event.target.value;
    setSelectedCourse(newCourse);

    if (newCourse !== "0") {
      getIaMarks([newCourse]);
    } else {
      const topicids =
        coursesBySemester[selectedSemester]?.map((course) => course.btid) || [];
      getIaMarks(topicids);
    }
  };

  const handleCheckboxChange = (item, index) => {
    if (!item.EID) {
      console.warn("Item missing EID:", item);
      return;
    }

    setIaMarksData((prevData) =>
      prevData.map((dataItem, i) =>
        i === index ? { ...dataItem, selected: !dataItem.selected } : dataItem
      )
    );

    setCheckedUsers((prev) => {
      const isChecked = item.selected;
      if (isChecked) {
        return prev.filter((user) => user.EID !== item.EID);
      } else {
        return [
          ...prev,
          {
            EID: item.EID,
            UNAME: item.UNAME,
            EMAILID: item.EMAILID,
            Iamarks: item.topics?.[selectedCourse]?.Iamarks ?? "",
            topics: { [selectedCourse]: item.topics?.[selectedCourse] },
          },
        ];
      }
    });
  };

  const handleMarksChange = (index, courseId, event) => {
    const newMarks = event.target.value;
    const parsedMarks = newMarks === "" ? "" : parseFloat(newMarks);

    setIaMarksData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
              ...item,
              topics: {
                ...item.topics,
                [courseId]: {
                  ...item.topics[courseId],
                  Iamarks: parsedMarks,
                },
              },
            }
          : item
      )
    );

    setCheckedUsers((prev) =>
      prev.map((user) =>
        user.EID === iaMarksData[index].EID
          ? {
              ...user,
              Iamarks: parsedMarks,
              topics: {
                ...user.topics,
                [courseId]: {
                  ...user.topics[courseId],
                  Iamarks: parsedMarks,
                },
              },
            }
          : user
      )
    );
  };

  const handleUpdateOrFreezeIaMarks = () => {
    if (checkedUsers.length === 0) {
      swal("Warning", "Please select at least one user", "warning");
      return;
    }

    if (checkedUsers.length > 0) {
      for (let i = 0; i < checkedUsers.length; i++) {
        if (checkedUsers[i].Iamarks > 25) {
          swal("Warning", "Marks should less than 25", "warning");
          return;
        }

        if (checkedUsers[i].Iamarks < 0) {
          swal("Warning", "Please enter valid marks", "warning");
          return;
        }
      }
    }

    swal({
      title: "Are you sure?",
      text: "You want to update and freeze IA Marks?",
      icon: "warning",
      buttons: { confirm: "Yes", cancel: "No" },
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        updateOrFreezeIaMarks();
      }
    });
  };

  async function updateOrFreezeIaMarks() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou?.bpid,
        topicids:
          selectedCourse === "0"
            ? coursesBySemester[selectedSemester]?.map((course) => course.btid)
            : [selectedCourse],
        users: checkedUsers,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/updateIaMarks`,
        bodyParam
      );
      swal("Success", "IA Marks updated successfully!", "success");

      handleClose();
    } catch (error) {
      console.error("Error in updateIaMarks:", error);
      swal("Error", "Something went wrong", "error");
      handleClose();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.maincontainer}>
      <div className={styles.iconcontainer}>
        <h3 className={styles.create}>IA Marks Update</h3>
        <Close className={styles.closebutton} onClick={handleClose} />
      </div>

      <div style={{ display: "flex", gap: "1rem" }}>
        <div className={styles.field}>
          <h3 className={styles.select}>Semester</h3>
          <select
            style={{
              border: "none",
              boxShadow: "0px 0px 5px 0px lightgrey",
              background: "white",
              height: "30px",
              margin: "10px 0 0 0",
              fontSize: "15px",
              paddingLeft: "10px",
            }}
            value={selectedSemester}
            onChange={handleSemesterChange}
            required
          >
            <option value="0">Select Semester</option>
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
            <option value="3">Semester 3</option>
            <option value="4">Semester 4</option>
            <option value="5">Semester 5</option>
            <option value="6">Semester 6</option>
          </select>
        </div>

        <div className={styles.field}>
          <h3 className={styles.select}>Select Course</h3>
          <select
            style={{
              border: "none",
              boxShadow: "0px 0px 5px 0px lightgrey",
              background: "white",
              height: "30px",
              margin: "10px 0 0 0",
              fontSize: "15px",
              paddingLeft: "10px",
            }}
            value={selectedCourse}
            onChange={handleCourseChange}
            required
          >
            <option value="0">Courses</option>
            {coursesBySemester[selectedSemester]?.map((item) => (
              <option key={item.btid || item.tid} value={item.btid || item.tid}>
                {item.ttitle}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div>
          {[...Array(4)].map((_, i) => (
            <Typography key={i} component="div" variant="h1">
              <Skeleton />
            </Typography>
          ))}
        </div>
      ) : (
        <>
          {/* {selectedCourse != 0 || selectedCourse != undefined ? (
            <Paper className={classes.paperSectionStyle}>
              <div
                style={{
                  padding: "1rem",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>
                  Course:
                  {selectedCourse === "0"
                    ? "All Courses"
                    : coursesBySemester[selectedSemester]?.find(
                        (course) => course.btid === selectedCourse
                      )?.ttitle || "N/A"}
                </h3>
                {checkedUsers.length > 0 && (
                  <button
                    style={{
                      backgroundColor: "var(--sub-heading-color)",
                      height: "30px",
                      fontSize: "1rem",
                      border: "none",
                      color: "white",
                      borderRadius: "4px",
                      padding: "0 1rem",
                    }}
                    onClick={handleUpdateOrFreezeIaMarks}
                  >
                    Update And Freeze IA Marks
                  </button>
                )}
              </div>

              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>
                      <Checkbox
                        checked={
                          iaMarksData.length > 0 &&
                          iaMarksData.every((item) => item.selected)
                        }
                        onChange={() => {
                          const allChecked = iaMarksData.every(
                            (item) => item.selected
                          );
                          setIaMarksData((prev) =>
                            prev.map((item) => ({
                              ...item,
                              selected: !allChecked,
                            }))
                          );
                          setCheckedUsers(
                            allChecked
                              ? []
                              : iaMarksData.map((item) => ({
                                  EID: item.EID,
                                  UNAME: item.UNAME,
                                  EMAILID: item.EMAILID,
                                  Iamarks:
                                    item.topics?.[selectedCourse]?.Iamarks ??
                                    "",
                                  topics: {
                                    [selectedCourse]:
                                      item.topics?.[selectedCourse],
                                  },
                                }))
                          );
                        }}
                      />
                    </th>
                    <th style={thStyle}>Name</th>
                    <th style={thStyle}>Marks Scored</th>
                    <th style={thStyle}>Concern Status</th>
                  </tr>
                </thead>
                <tbody>
                  {iaMarksData.length > 0 ? (
                    iaMarksData.map((item, index) => (
                      <tr key={item.EID || index}>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            fontSize: "14px",
                            width: "5%",
                          }}
                        >
                          <Checkbox
                            checked={item.selected || false}
                            onChange={() => handleCheckboxChange(item, index)}
                          />
                        </td>
                        <td style={tdStyle1}>{item.UNAME || "N/A"}</td>
                        <td style={tdStyle1}>
                          <input
                            style={{
                              border: "none",
                              boxShadow: "0px 0px 5px 0px lightgrey",
                              background: "white",
                              height: "30px",
                              fontSize: "15px",
                              paddingLeft: "10px",
                              width: "100px",
                            }}
                            type="number"
                            value={item.topics?.[selectedCourse]?.Iamarks ?? ""}
                            onChange={(e) =>
                              handleMarksChange(index, selectedCourse, e)
                            }
                            disabled={
                              item.topics?.[selectedCourse]?.concernRaised ===
                                true ||
                              item.topics?.[selectedCourse]?.concernRaised ===
                                "Updated" ||
                              item.topics?.[selectedCourse]?.showIaMarks ===
                                true
                            }
                          />
                        </td>
                        <td style={tdStyle1}>
                          {item.topics?.[selectedCourse]?.concernRaised && (
                            <button
                              style={{
                                backgroundColor: "var(--sub-heading-color)",
                                height: "30px",
                                fontSize: "1rem",
                                border: "none",
                                color: "white",
                                borderRadius: "4px",
                                padding: "0 1rem",
                              }}
                              disabled
                            >
                              {item.topics?.[selectedCourse]?.concernRaised ===
                              "true"
                                ? "Concern Raised"
                                : item.topics?.[selectedCourse]
                                    ?.concernRaised === "Updated"
                                ? "Updated"
                                : "No Concern"}
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ ...classes.tdStyle, textAlign: "center" }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Paper>
          ) : (
            <></>
          )} */}

          {selectedCourse !== "0" && selectedCourse !== undefined ? (
            <Paper className={classes.paperSectionStyle}>
              <div
                style={{
                  padding: "1rem",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>
                  Course:
                  {selectedCourse === "0"
                    ? "All Courses"
                    : coursesBySemester[selectedSemester]?.find(
                        (course) => course.btid === selectedCourse
                      )?.ttitle || "N/A"}
                </h3>
                {checkedUsers.length > 0 && (
                  <button
                    style={{
                      backgroundColor: "var(--sub-heading-color)",
                      height: "30px",
                      fontSize: "1.4rem",
                      border: "none",
                      color: "white",
                      borderRadius: "4px",
                      padding: "0 1rem",
                    }}
                    onClick={handleUpdateOrFreezeIaMarks}
                  >
                    Update And Freeze IA Marks
                  </button>
                )}
              </div>

              {/* <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>
                      <Checkbox
                        checked={
                          iaMarksData.length > 0 &&
                          iaMarksData.every((item) => item.selected)
                        }
                        onChange={() => {
                          const allChecked = iaMarksData.every(
                            (item) => item.selected
                          );
                          setIaMarksData((prev) =>
                            prev.map((item) => ({
                              ...item,
                              selected: !allChecked,
                            }))
                          );
                          setCheckedUsers(
                            allChecked
                              ? []
                              : iaMarksData.map((item) => ({
                                  EID: item.EID,
                                  UNAME: item.UNAME,
                                  EMAILID: item.EMAILID,
                                  Iamarks:
                                    item.topics?.[selectedCourse]?.Iamarks ??
                                    "",
                                  topics: {
                                    [selectedCourse]:
                                      item.topics?.[selectedCourse],
                                  },
                                }))
                          );
                        }}
                      />
                    </th>
                    <th style={thStyle}>Name</th>
                    <th style={thStyle}>Marks Scored</th>
                    <th style={thStyle}>Concern Status</th>
                    <th style={thStyle}>Concern Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {iaMarksData.length > 0 ? (
                    iaMarksData.map((item, index) => (
                      <tr key={item.EID || index}>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            fontSize: "14px",
                            width: "5%",
                          }}
                        >
                          <Checkbox
                            checked={item.selected || false}
                            onChange={() => handleCheckboxChange(item, index)}
                          />
                        </td>
                        <td style={tdStyle1}>{item?.UNAME}</td>
                        <td style={tdStyle1}>
                          <input
                            style={{
                              border: "none",
                              boxShadow: "0px 0px 5px 0px lightgrey",
                              fontWeight: 500,
                              height: "30px",
                              fontSize: "15px",
                              paddingLeft: "10px",
                              width: "100px",
                            }}
                            type="number"
                            value={item.topics?.[selectedCourse]?.Iamarks ?? ""}
                            onChange={(e) =>
                              handleMarksChange(index, selectedCourse, e)
                            }
                            disabled={
                              item.topics?.[selectedCourse]?.concernRaised !=
                              undefined
                                ? item.topics?.[selectedCourse]
                                    ?.concernRaised == "false" ||
                                  item.topics?.[selectedCourse]
                                    ?.concernRaised == "Updated"
                                : item.topics?.[selectedCourse]?.showIaMarks ==
                                  true
                            }
                          />
                        </td>
                        <td style={tdStyle1}>
                          <div>
                            {item.topics?.[selectedCourse]?.concernRaised && (
                              <button
                                style={{
                                  backgroundColor: "var(--sub-heading-color)",
                                  height: "30px",
                                  fontSize: "1.4rem",
                                  border: "none",
                                  color: "white",
                                  borderRadius: "4px",
                                  padding: "0 1rem",
                                }}
                                disabled
                              >
                                {item.topics?.[selectedCourse]
                                  ?.concernRaised === "true"
                                  ? "Concern Raised"
                                  : item.topics?.[selectedCourse]
                                      ?.concernRaised === "Updated"
                                  ? "Updated"
                                  : "No Concern"}
                              </button>
                            )}
                          </div>
                        </td>

                        <td style={tdStyle1}>
                          <div style={{backgroundColor:"red",width:"rem"}}>{item.topics?.[selectedCourse]?.reason}</div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ ...classes.tdStyle, textAlign: "center" }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table> */}

              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={{ ...thStyle, width: "5%" }}>
                      <Checkbox
                        checked={
                          iaMarksData.length > 0 &&
                          iaMarksData.every((item) => item.selected)
                        }
                        onChange={() => {
                          const allChecked = iaMarksData.every(
                            (item) => item.selected
                          );
                          setIaMarksData((prev) =>
                            prev.map((item) => ({
                              ...item,
                              selected: !allChecked,
                            }))
                          );
                          setCheckedUsers(
                            allChecked
                              ? []
                              : iaMarksData.map((item) => ({
                                  EID: item.EID,
                                  UNAME: item.UNAME,
                                  EMAILID: item.EMAILID,
                                  Iamarks:
                                    item.topics?.[selectedCourse]?.Iamarks ??
                                    "",
                                  topics: {
                                    [selectedCourse]:
                                      item.topics?.[selectedCourse],
                                  },
                                }))
                          );
                        }}
                      />
                    </th>
                    <th style={{ ...thStyle, width: "20%" }}>Name</th>
                    <th style={{ ...thStyle, width: "20%" }}>Marks Scored</th>
                    <th style={{ ...thStyle, width: "25%" }}>Concern Status</th>
                    <th style={{ ...thStyle, width: "30%" }}>Concern Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {iaMarksData.length > 0 ? (
                    iaMarksData.map((item, index) => (
                      <tr key={item.EID || index}>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            fontSize: "14px",
                            width: "5%",
                          }}
                        >
                          <Checkbox
                            checked={item.selected || false}
                            onChange={() => handleCheckboxChange(item, index)}
                          />
                        </td>
                        <td style={{ ...tdStyle1, width: "20%" }}>
                          {item?.UNAME}
                        </td>
                        <td style={{ ...tdStyle1, width: "20%" }}>
                          <input
                            style={{
                              border: "none",
                              boxShadow: "0px 0px 5px 0px lightgrey",
                              fontWeight: 500,
                              height: "30px",
                              fontSize: "15px",
                              paddingLeft: "10px",
                              width: "100px",
                            }}
                            type="number"
                            value={item.topics?.[selectedCourse]?.Iamarks ?? ""}
                            onChange={(e) =>
                              handleMarksChange(index, selectedCourse, e)
                            }
                            disabled={
                              item.topics?.[selectedCourse]?.concernRaised !=
                              undefined
                                ? item.topics?.[selectedCourse]
                                    ?.concernRaised == "false" ||
                                  item.topics?.[selectedCourse]
                                    ?.concernRaised == "Updated"
                                : item.topics?.[selectedCourse]?.showIaMarks ==
                                  true
                            }
                          />
                        </td>
                        <td style={{ ...tdStyle1, width: "25%" }}>
                          <div>
                            {item.topics?.[selectedCourse]?.concernRaised && (
                              <button
                                style={{
                                  backgroundColor: "var(--sub-heading-color)",
                                  height: "30px",
                                  fontSize: "1.4rem",
                                  border: "none",
                                  color: "white",
                                  borderRadius: "4px",
                                  padding: "0 1rem",
                                }}
                                disabled
                              >
                                {item.topics?.[selectedCourse]
                                  ?.concernRaised === "true"
                                  ? "Concern Raised"
                                  : item.topics?.[selectedCourse]
                                      ?.concernRaised === "Updated"
                                  ? "Updated"
                                  : "No Concern"}
                              </button>
                            )}
                          </div>
                        </td>

                        <td style={{ ...tdStyle1, width: "30%" }}>
                          <div>
                            {item.topics?.[selectedCourse]?.reason || "-"}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        style={{ ...tdStyle1, textAlign: "center" }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Paper>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default IaMarks;
